var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWlrs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "74px",
    height: "72px",
    viewBox: "0 0 74 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 43.4,
    y1: 463.4,
    x2: 913.47,
    y2: 463.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(90.980392%,85.490196%,92.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(81.960784%,84.705882%,89.411765%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "url(#linear0)",
      strokeWidth: 22.28,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(28.235294%,31.764706%,40%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 913.473286 463.394971 C 913.473286 703.673844 718.703936 898.434049 478.458255 898.434049 C 238.162323 898.434049 43.392973 703.673844 43.392973 463.394971 C 43.392973 223.116097 238.162323 28.355892 478.458255 28.355892 C 718.703936 28.355892 913.473286 223.116097 913.473286 463.394971 Z M 913.473286 463.394971 ",
    transform: "matrix(0.0777362,0,0,0.078522,0.0135148,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20%,28.235294%,46.27451%)",
      fillOpacity: 1
    },
    d: "M 16.394531 40.722656 L 29.132812 37.691406 L 20.167969 24.65625 L 20.035156 14.507812 L 22.476562 9.839844 L 27.4375 9.839844 L 31.847656 6.414062 L 39.863281 6.414062 L 53.035156 12.449219 L 63.273438 21.261719 L 68.09375 32.753906 L 65.9375 49.078125 L 56.023438 58.40625 L 46.246094 64.992188 L 38.234375 66.363281 L 28.183594 65.128906 L 17.316406 58.816406 L 9.167969 49.214844 L 6.316406 40.160156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.647059%,75.686275%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 19.714844 28.074219 L 25.183594 26.578125 L 30.347656 28.820312 L 36.335938 28.820312 L 42.425781 24.824219 L 47.898438 29.308594 L 49.652344 35.84375 L 49.652344 43.550781 L 54.09375 35.160156 L 52.957031 25.992188 L 58.328125 32.722656 L 59.152344 37.792969 L 56.570312 48.425781 L 62.558594 40.625 L 62.558594 29.699219 L 59.667969 20.628906 L 54.300781 14.582031 L 45.957031 11.625 L 38.046875 7.167969 L 30.96875 9.121094 L 27.765625 11.167969 L 24.875 11.070312 L 21.984375 12.824219 L 20.847656 15.558594 L 18.164062 18.484375 L 16.925781 22.480469 L 17.546875 25.117188 Z M 19.714844 28.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(24.705882%,33.72549%,53.333333%)",
      fillOpacity: 1
    },
    d: "M 15.566406 22.394531 L 16.722656 18.894531 L 20.457031 14.574219 L 22.902344 14.917969 L 25.890625 11.625 L 33.632812 13.410156 L 37.207031 17.007812 L 38.589844 19.511719 L 38.589844 26.304688 L 31.253906 22.875 L 27.996094 21.089844 L 23.71875 22.257812 L 21.300781 26.304688 L 19.4375 28.910156 L 16.722656 25.824219 Z M 15.566406 22.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(24.705882%,33.72549%,53.333333%)",
      fillOpacity: 1,
      strokeWidth: 3.71,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(72.54902%,89.411765%,98.039216%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 452.529208 135.809798 L 468.257486 113.970787 L 496.246787 113.970787 L 525.94459 141.928701 L 525.94459 178.642119 L 508.457559 200.481131 L 464.79023 177.74667 Z M 452.529208 135.809798 ",
    transform: "matrix(0.0777362,0,0,0.078522,0.0135148,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,27.058824%,44.313725%)",
      fillOpacity: 1
    },
    d: "M 35.191406 10.664062 L 38.589844 11.710938 L 36.144531 13.957031 Z M 35.191406 10.664062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,27.058824%,44.313725%)",
      fillOpacity: 1
    },
    d: "M 38.589844 11.710938 L 39.539062 15.742188 L 40.898438 14.027344 Z M 38.589844 11.710938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(42.745098%,59.215686%,74.509804%)",
      fillOpacity: 1
    },
    d: "M 38.589844 11.710938 L 38.589844 8.949219 L 40.898438 11.144531 Z M 38.589844 11.710938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.980392%,13.72549%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 16.925781 26.054688 L 18.402344 22.613281 L 21.882812 21.875 L 23.71875 22.257812 L 20.21875 29.390625 L 18.550781 27.902344 Z M 16.925781 26.054688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.980392%,13.72549%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 27.996094 21.089844 L 34.75 21.089844 L 38.589844 26.304688 L 33.734375 24.039062 L 31.027344 22.75 Z M 27.996094 21.089844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,62.352941%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 20.832031 27.402344 L 25.921875 23.699219 L 30.347656 28.820312 L 25.09375 27.074219 Z M 20.832031 27.402344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,62.352941%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 36.335938 28.820312 L 42.75 22.257812 L 47.898438 29.308594 L 42.425781 24.824219 Z M 36.335938 28.820312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,62.352941%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 49.652344 43.550781 L 51.660156 35.496094 L 47.898438 29.308594 L 49.652344 35.84375 Z M 49.652344 43.550781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,62.352941%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 56.570312 48.425781 L 59.152344 37.792969 L 58.328125 32.722656 L 60.828125 38.511719 Z M 56.570312 48.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(24.705882%,33.72549%,53.333333%)",
      fillOpacity: 1
    },
    d: "M 6.316406 40.160156 L 15.566406 45.714844 L 9.167969 49.214844 L 19.472656 52.246094 L 17.316406 58.816406 L 36.375 58.0625 L 43.105469 61.886719 L 51.660156 58.679688 L 65.9375 49.078125 L 55.441406 59.574219 L 46.246094 64.992188 L 37.207031 66.910156 L 28.183594 65.128906 L 19.25 59.941406 L 17.441406 58.890625 L 17.140625 58.605469 L 9.398438 49.484375 L 9.0625 48.878906 Z M 6.316406 40.160156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(72.54902%,89.411765%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 18.402344 25.003906 L 20.21875 22.566406 L 22.789062 22.667969 L 22.472656 33.234375 L 24.144531 43.140625 L 28.945312 54.023438 L 31.503906 58.546875 L 32.039062 61.886719 L 29.050781 60.378906 L 25.425781 55.421875 L 20.519531 44.109375 L 18.707031 32.90625 Z M 18.402344 25.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 20.21875 22.566406 L 22.472656 33.234375 L 22.789062 22.667969 Z M 20.21875 22.566406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(88.627451%,95.686275%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 20.519531 44.109375 L 27.4375 54.425781 L 29.050781 60.378906 L 25.425781 55.421875 Z M 20.519531 44.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 32.039062 61.886719 L 29.40625 57.996094 L 31.503906 58.546875 Z M 32.039062 61.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(72.54902%,89.411765%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 30.863281 21.875 L 33.917969 22 L 36.375 24.1875 L 36.175781 30.921875 L 37.84375 40.824219 L 42.644531 51.707031 L 45.203125 56.230469 L 45.738281 59.574219 L 42.75 58.0625 L 39.125 53.109375 L 34.21875 41.796875 L 32.40625 30.589844 Z M 30.863281 21.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 33.917969 22 L 36.261719 28.003906 L 36.375 24.1875 Z M 33.917969 22 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(88.627451%,95.686275%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 34.21875 41.796875 L 41.136719 52.113281 L 42.75 58.0625 L 39.125 53.109375 Z M 34.21875 41.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 45.738281 59.574219 L 43.105469 55.679688 L 45.203125 56.230469 Z M 45.738281 59.574219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 3.71,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(80.784314%,92.156863%,98.431373%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 452.529208 135.809798 L 468.257486 113.970787 L 496.246787 113.970787 L 525.94459 141.928701 L 525.94459 178.642119 L 508.457559 200.481131 L 464.79023 177.74667 Z M 452.529208 135.809798 ",
    transform: "matrix(0.0777362,0,0,0.078522,0.0135148,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,62.352941%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 43.082031 21.875 L 50.875 28.910156 L 52.503906 35.648438 L 49.5 28.910156 Z M 43.082031 21.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,62.352941%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 54.1875 25.78125 L 59.738281 31.996094 L 61.671875 38.632812 L 60.398438 31.484375 Z M 54.1875 25.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(78.039216%,81.960784%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 48.378906 13.324219 L 53.933594 15.175781 L 58.972656 20.832031 L 53.015625 15.742188 Z M 48.378906 13.324219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(88.627451%,95.686275%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 18.707031 32.90625 L 24.144531 43.140625 L 20.519531 44.109375 Z M 18.707031 32.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(88.627451%,95.686275%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 34.21875 41.796875 L 37.84375 40.824219 L 31.527344 25.632812 Z M 34.21875 41.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 37.84375 40.824219 L 41.136719 52.113281 L 42.644531 51.707031 Z M 37.84375 40.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 24.144531 43.140625 L 27.4375 54.425781 L 28.945312 54.023438 Z M 24.144531 43.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 18.652344 31.515625 L 19.375 23.699219 L 18.402344 25.003906 Z M 18.652344 31.515625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 30.863281 21.875 L 33.917969 26.714844 L 33.609375 30.640625 L 31.527344 25.632812 Z M 30.863281 21.875 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlrs);
export default __webpack_public_path__ + "static/media/wlrs.521fcb8ef0d7d8d5e36dd726e9395017.svg";
export { ForwardRef as ReactComponent };